import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import moment from "moment"

/*Event Calendar Text Styling
function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i className="action-icons" onClick={this.viewEvent}>{eventInfo.event.title}</i>
    </>
  )
}*/

class EventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data         :[],
      isLoading    :true,
      show         :false,
      calendarView :true
    };
    this.renderEventContent = this.renderEventContent.bind(this);
    this.viewEvent = this.viewEvent.bind(this);
  }

  async getEvents() {
    try {
      const response = await fetch('/api/events');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getEvents();
  }

  viewEvent(e) {
    const id = parseInt(e.target.id);
    const events = this.state.data;
    const selectedEvent = events.filter(e=> e.id === id)[0];
    this.setState(selectedEvent);
    this.setState({ show: true });
  }

  renderEventContent(eventInfo) {
    return (
      <>
        <p id={eventInfo.event.id} className="action-icons text-wrap" onClick={this.viewEvent}>{eventInfo.event.title}</p>
      </>
    )
  }

  render() {
    if(!this.state.isLoading){
      if(this.state.show === false) {
        const events = this.state.data;
        const event_list = events.map((event)=>
            <tr key={event.id} id={event.id}>
                <td>{event.title}</td>
                <td>{event.start_time}</td>
                <td>{event.venue}</td>
                <td><button id={event.id} className="btn btn-sm btn-info" onClick={this.viewEvent}>View details</button></td>
            </tr>
        );
        return(
            <>
            <div className="row">
                <div className="col-12">
                    {this.state.calendarView?(
                      <div className="bg-white p-3 rounded border shadow-sm">
                        <FullCalendar
                          plugins={[ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin ]}
                          initialView="dayGridMonth"
                          headerToolbar={{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth,timeGridWeek,listWeek'
                          }}
                          weekends={true}
                          events={this.state.data}
                          eventContent={this.renderEventContent}
                        />
                      </div>
                    ):(
                      <>
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h4 className="m-0 font-weight-bold text-white">Events</h4>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive event-table">
                                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Event Date</th>
                                                <th>Venue</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {event_list}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-primary" onClick={this.addEvent}><i className="fas fa-plus"></i> New Event</button>
                      </>
                    )}
                </div>
            </div>
            </>
        );

      }else{
        
          return (
            <>
              <div className="container-fluid">
                  <div className="card shadow mb-4">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-white">{this.state.title?this.state.title:'Register an Event'}</h4>
                      </div>
                      <div className="card-body event-view">
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Event Title</span>
                          </div>
                          <div className="col-md-10">
                            <span className="font-weight-bold text-dark"> {this.state.title} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Event Start's On </span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {moment(this.state.start_time, "YYYY-MM-DDTHH:mm:ss").format("LLL")} </span>
                          </div>
                          <div className="col-md-2">
                            <span>End's On </span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {moment(this.state.end_time, "YYYY-MM-DDTHH:mm:ss").format("LLL")} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Venue </span>
                          </div>
                          <div className="col-md-10">
                            <span className="font-weight-bold text-dark"> {this.state.venue} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Organizers </span>
                          </div>
                          <div className="col-md-10">
                            <span className="font-weight-bold text-dark"> {this.state.organizers} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Contact Person </span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {this.state.contact_person} </span>
                          </div>
                          <div className="col-md-2">
                            <span>Position </span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {this.state.contact_person_position} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Contact Phone </span>
                          </div>
                          <div className="col-md-4">                            
                            <span className="font-weight-bold text-dark"> {this.state.contact_phone} </span>
                          </div>
                          <div className="col-md-2">
                            <span>Status </span>
                          </div>
                          <div className="col-md-4">                            
                            <span className="font-weight-bold text-primary"> {this.state.status?"Active":"Inactive"} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col">
                            <span>Description </span>
                            <span className="px-2" dangerouslySetInnerHTML={{ __html: this.state.description }}></span>
                          </div>
                        </div>
                        <div className="mt-2">
                          {this.state.file_url?
                            <>
                              <a target="_blank" href={this.state.file_url} className="btn btn-bg-success">View Event File</a>
                            </>:
                            <></>
                          }
                          <button className="btn btn-danger float-right" onClick={()=>this.setState({show:false})}> Close </button>
                        </div>
                      </div>
                  </div>
              </div>
            </>
          )
        }
      }
    }
}

function Events() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <EventList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Events };
